import styled from 'styled-components';

export const SelectorRow = styled.div`
  padding: 20px 0;
  border-bottom: 1px solid var(--line-gray);
`;

export const Columns = styled.div`
  display: flex;
  flex-flow: row;
  flex: 1;
  min-height: 0;

  & > * + * {
    border-left: solid 1px var(--line-gray);
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: 25px 30px 30px;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }

  &.wide {
    flex: 2;
  }
`;

export const ColumnTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  font-size: 16px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

export const ColumnTitleCount = styled.span`
  font-family: var(--font-regular);
  color: var(--text-secondary);
`;

export const EmptyMessage = styled.div`
  font-size: 14px;
  color: var(--text-secondary);
`;
